// Formato de nombre para docentes: "PROFR. / PROFRA." + nombre completo en MAYÚSCULAS.
// - Hombre (genero === "H") → "PROFR."
// - Mujer  (genero === "M") → "PROFRA."
// - Sin género → sin prefijo
// Si el usuario no es docente, devuelve el nombre en su forma original.
export function fullName(u) {
  if (!u) return "";
  const built = [u.apellido_paterno, u.apellido_materno, u.nombre].filter(Boolean).join(" ").trim();
  return built || u.name || u.nombre || "";
}

export function docenteLabel(u) {
  if (!u) return "";
  const name = fullName(u).toUpperCase();
  if (u.role && u.role !== "docente") return name;
  const prefix = u.genero === "M" ? "PROFRA." : u.genero === "H" ? "PROFR." : "";
  return prefix ? `${prefix} ${name}` : name;
}

export function userLabel(u) {
  if (!u) return "";
  if (u.role === "docente") return docenteLabel(u);
  return fullName(u);
}
